import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

import { buildLabelUrl } from '@confluence/macro-utils/entry-points/labelUrl.ts';

import type { PopularLabelData } from './popularLabelsTypes.ts';

interface ListLayoutProps {
	labels: PopularLabelData[];
	spaceKey?: string;
	/**
	 * Forwarded to each link's `target` attribute. Set to `'_blank'` in editor
	 * mode so author-side clicks open in a new tab; left undefined in view
	 * mode so the link navigates in place (legacy behavior).
	 */
	linkTarget?: '_blank';
}

const styles = cssMap({
	list: {
		listStyleType: 'none',
		paddingInlineStart: token('space.0'),
	},
	link: {
		textDecoration: 'none',
	},
});

export const ListLayout = ({
	labels,
	spaceKey,
	linkTarget,
}: ListLayoutProps): React.JSX.Element => {
	return (
		<Stack as="ul" xcss={styles.list} testId="popular-labels-list">
			{labels.map((label) => (
				<li key={label.labelId}>
					<Anchor href={buildLabelUrl(label.name, spaceKey)} target={linkTarget} xcss={styles.link}>
						{label.name}
					</Anchor>
				</li>
			))}
		</Stack>
	);
};
